import { useDispatch } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';
import {
    ExportsPaths,
    SettingsPaths
} from '@/services/dictionaries/Paths';
import { useDashboardElementVisibility } from '@/services/hooks/useDashboardElementVisibility';

interface ProfileMenuItem {
    label: string,
    onClick: () => void
}

export const useProfileMenuAdditionalItems = (): ProfileMenuItem[] => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isCreatorMenuVisible } = useDashboardElementVisibility();

    if (!isCreatorMenuVisible) {
        return [];
    }

    const onSettingsClick = (): void => {
        dispatch(Push(SettingsPaths.Settings))
    };
    const onExportsClick = (): void => {
        dispatch(Push(ExportsPaths.Exports))
    };
    
    return [
        {
            label: t('settings'),
            onClick: onSettingsClick
        },
        {
            label: t('exports'),
            onClick: onExportsClick
        }
    ];
};
